import { PublicEducator } from '@cademy-package/sdk-component-types';
import classNames from 'classnames';
import { FunctionComponent } from 'react';
import AddCourseReviewLink from '../../../../../components/AddCourseReviewLink';
import ShowAllButton from './ShowAllButton';
import styles from './styles.module.scss';

type ControlBarProps = {
    count: number;
    educator: PublicEducator;
    courseSlug: string;
    className?: string;
    showAll: () => void;
};

const ControlBar: FunctionComponent<ControlBarProps> = ({
    count,
    educator,
    courseSlug,
    className,
    showAll,
}) => {
    return (
        <>
            <div className={classNames(styles.controlBar, className)}>
                <ShowAllButton count={count} onClick={showAll} />
                <AddCourseReviewLink
                    educatorSlug={educator.slug}
                    courseSlug={courseSlug}
                    button={true}
                    className={styles.addReviewBtn}
                >
                    + Add Review
                </AddCourseReviewLink>
            </div>
        </>
    );
};

export default ControlBar;
